import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InsuranceSelectorPage } from './insurance-selector';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    InsuranceSelectorPage,
  ],
  imports: [
    IonicPageModule.forChild(InsuranceSelectorPage),
    ComponentsModule
  ],
})
export class InsuranceSelectorPageModule {}



// WEBPACK FOOTER //
// ./src/pages/insurance-selector/insurance-selector.module.ts